import React, { useState, useEffect, useRef } from "react";
import { FaEnvelope, FaSearch, FaMicrophone, FaPlane } from "react-icons/fa";
import { MdCall, MdVideocam } from "react-icons/md";
import { IoChevronBack } from "react-icons/io5";
import axios from "axios";
import io from "socket.io-client";
import { baseurl, imageUrl } from "../Baseurl";
import { Send } from "react-feather";
import { useNavigate } from "react-router-dom";
import { BsFillHeartFill, BsPin, BsPinFill } from "react-icons/bs";
import { BiHeart } from "react-icons/bi";

const socket = io(baseurl.replace("/api", ""));

// const socket = io("https://bosplannew.evventoz.com/", {
//   transports: ["websocket"], 
//   upgrade: true,
// });

export default function ChatView() {
  const [showChat, setShowChat] = useState(false);
  const [activeUser, setActiveUser] = useState(null);
  const [user, setUser] = useState(null);
  const [users, setUsers] = useState([]);
  const [messages, setMessages] = useState([]);
  const [newMsg, setNewMsg] = useState("");
  const [loadingMessages, setLoadingMessages] = useState(false);
  const [searchQuery, setSearchQuery] = useState(""); // 🔹 new state
  const scrollRef = useRef();

  const navigate = useNavigate();
  const [darkMode, setDarkMode] = useState(false);
  useEffect(() => {
    const adminId = localStorage.getItem("adminID");
    if (!adminId) {
      navigate("/");
    }

    // 👇 load dark mode preference
    const savedTheme = localStorage.getItem("darkMode") === "true";
    setDarkMode(savedTheme);
    document.body.classList.toggle("dark", savedTheme);
  }, [navigate]);

  // ✅ Filtered users
// Users filter
const filteredUsers = users.filter((u) =>
  (u.full_name || "").toLowerCase().includes((searchQuery || "").toLowerCase())
);



  const [pinnedMessages, setPinnedMessages] = useState([]);
const [pinnedSearchQuery, setPinnedSearchQuery] = useState("");


// Pinned messages filter
const filteredPinnedMessages = pinnedMessages.filter((msg) =>
  (msg.message || "").toLowerCase().includes((pinnedSearchQuery || "").toLowerCase())
);


const togglePin = (msg) => {
  const isCurrentlyPinned = pinnedMessages.some((m) => m.id === msg.id);

  // Emit to backend
  socket.emit('togglePin', { messageId: msg.id, pinned: !isCurrentlyPinned });

  // Update local state
  if (isCurrentlyPinned) {
    setPinnedMessages(pinnedMessages.filter((m) => m.id !== msg.id));
  } else {
    setPinnedMessages([...pinnedMessages, msg]);
  }
};


// Listen for backend updates
useEffect(() => {
  socket.on('updatePinnedMessage', (updatedMsg) => {
    setMessages((prev) =>
      prev.map((m) => (m.id === updatedMsg.id ? updatedMsg : m))
    );

    if (updatedMsg.pinned) {
      setPinnedMessages((prev) => [...prev.filter((m) => m.id !== updatedMsg.id), updatedMsg]);
    } else {
      setPinnedMessages((prev) => prev.filter((m) => m.id !== updatedMsg.id));
    }
  });

  return () => socket.off('updatePinnedMessage');
}, []);

  // 1. Fetch logged-in user
  useEffect(() => {
    const adminID = localStorage.getItem("adminID");
    if (adminID) {
      axios
        .get(`${baseurl}getUserById/${adminID}`)
        .then((res) => setUser(res.data))
        .catch((err) => console.error("Error fetching user:", err));
    }
  }, []);

  // 2. Fetch available users
  useEffect(() => {
    const orgId = localStorage.getItem("organization_id");
    if (orgId) {
      axios
        .get(`${baseurl}getAssigneesByOrgId/${orgId}`)
        .then((res) => setUsers(res.data.assignees || []))
        .catch((err) => console.error("Error fetching assignees:", err));
    }
  }, []);

  // 3. Fetch messages when activeUser changes
  useEffect(() => {
    if (user && activeUser) {
      setLoadingMessages(true);
      socket.emit("getMessages", {
        sender_type: "user",
        sender_id: user.id,
        receiver_type: "assignee",
        receiver_id: activeUser.id,
      });
    }
  }, [user, activeUser]);

  // 4. Listen for socket events
  useEffect(() => {
    socket.on("chatHistory", (msgs) => {
  // Get pinned messages
  const pinned = msgs.filter((m) => m.pinned);
  setPinnedMessages(pinned);

  // Set all messages
  setMessages(msgs);
  setLoadingMessages(false);
  scrollToBottom();
});

    socket.on("newMessage", (msg) => {
      const isRelevant =
        (msg.sender_id === activeUser?.id && msg.receiver_id === user?.id) ||
        (msg.sender_id === user?.id && msg.receiver_id === activeUser?.id);

      if (isRelevant) {
        setMessages((prev) => [...prev, msg]);
        scrollToBottom();
      }
    });

    return () => {
      socket.off("chatHistory");
      socket.off("newMessage");
    };
  }, [activeUser, user]);

  const handleSend = () => {
    if (newMsg.trim() && user && activeUser) {
      socket.emit("sendMessage", {
        sender_type: "user",
        sender_id: user.id,
        receiver_type: "assignee",
        receiver_id: activeUser.id,
        message: newMsg,
      });
      setNewMsg("");
    }
  };

  const scrollToBottom = () => {
    setTimeout(() => {
      scrollRef.current?.scrollIntoView({ behavior: "smooth" });
    }, 100);
  };

  return (
    <>
      {/* Floating Chat Button */}
      <button
        className="btn btn-light mb-3"
        onClick={() => setShowChat(!showChat)}
      >
        <FaEnvelope size={20} />
      </button>

      {/* Chat Popup */}
      {showChat && (
        <div className={`chat-popup pcard ${darkMode ? "dark" : ""}`}>
          {/* If no user selected → show Direct Messages */}
          {!activeUser ? (
            <>
              {/* Header */}
              <div
                className="chat-header p-2 text-white fw-bold"
                style={{
                  borderTopLeftRadius: "12px",
                  borderTopRightRadius: "12px",
                  background:
                    "linear-gradient(45deg, #d16ba5, #86a8e7, #5ffbf1)",
                }}
              >
                Direct Messages
              </div>

              {/* Search */}
              <div
                className={`p-2 border-bottom  pcard ${darkMode ? "dark" : ""}`}
              >
                <div className="p-2 border-bottom d-flex align-items-center  ">
                  <FaSearch className="me-2 text-muted" />
                  <input
                    type="text"
                    className="form-control border-0 bg-light"
                    placeholder="Search..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                </div>

                {/* 🔹 Search Result Bubbles */}
                {/* {searchQuery && (
  <div className="d-flex flex-wrap gap-2">
    {filteredUsers.length > 0 ? (
      filteredUsers.map((u) => (
        <span
          key={u.id}
          onClick={() => setActiveUser(u)}
          className="d-flex align-items-center gap-2 px-2 py-1 rounded-pill text-white small"
          style={{
            background: "linear-gradient(45deg,#6a11cb,#2575fc)",
            cursor: "pointer",
          }}
        > 
          <img
            src={`${imageUrl}assignee/${u.profile_image}` || "https://via.placeholder.com/30"}
            alt={u.full_name}
            className="rounded-circle"
            style={{ width: "24px", height: "24px", objectFit: "cover" }}
          /> 
          {u.full_name}
        </span>
      ))
    ) : (
      <span className="text-muted small">No users found</span>
    )}
  </div>
)} */}
              </div>

              {/* User List */}
              <div className="chat-body flex-grow-1 p-2 overflow-auto">
                {filteredUsers.length > 0 ? (
                  filteredUsers.map((u) => (
                    <div
                      key={u.id}
                      className=" p-2 border-bottom hover-bg"
                      onClick={() => setActiveUser(u)}
                      style={{ cursor: "pointer" }}
                    >
                      <div className="d-flex align-items-center justify-content-between">
                        {/* Left: Avatar + Info */}
                        <div className="d-flex align-items-center">
                          <img
                            src={`${imageUrl}assignee/${u.profile_image}`}
                            alt={u.full_name}
                            className="rounded-circle me-2"
                            width="40"
                            height="40"
                          />
                          <div>
                            <div className="fw-bold">{u.full_name}</div>
                            <div className="text-muted small">
                              {u.department} • {u.role}
                            </div>
                          </div>
                        </div>

                        {/* Right: Call / Video Icons */}
                        {/* <div>
                          <MdCall className="text-primary me-2" />
                          <MdVideocam className="text-success" />
                        </div> */}
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="text-center text-muted small p-3">
                    No users found
                  </div>
                )}
              </div>
            </>
          ) : (
            <>
              {/* Chat Header with Back Button */}
              <div
                className={`chat-header p-2 d-flex align-items-center pcard ${
                  darkMode ? "dark" : ""
                }`}
                style={{
                  borderTopLeftRadius: "12px",
                  borderTopRightRadius: "12px",
                  background:
                    "linear-gradient(45deg, #d16ba5, #86a8e7, #5ffbf1)",
                }}
              >
                <IoChevronBack
                  size={24}
                  className="me-2"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setActiveUser(null);
                    setMessages([]);
                  }}
                />
                <img
                  src={`${imageUrl}assignee/${activeUser.profile_image}`}
                  alt={activeUser.full_name}
                  className="rounded-circle me-2"
                  width="35"
                  height="35"
                />
                <div className="fw-bold">{activeUser.full_name}</div>
              </div>

              {/* Chat Messages */}
              <div
  className={`chat-body flex-grow-1 p-3 overflow-auto pcard ${
    darkMode ? "dark" : ""
  }`}
  style={{ background: "#fff", maxHeight: "385px" }}
>
  {loadingMessages ? (
    <div className="d-flex justify-content-center p-5">
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  ) : (
    <>
      {messages.map((msg, idx) => {
        const isMe = msg.sender_id === user?.id;
        const isPinned = pinnedMessages.some((m) => m.id === msg.id);

        // Function to convert URLs to <a> tags
        const renderMessage = (text) => {
          const urlRegex = /(\bhttps?:\/\/[^\s]+)/gi;
          const parts = text.split(urlRegex);

          return parts.map((part, i) => {
            if (urlRegex.test(part)) {
              return (
                <a
                  key={i}
                  href={part}
                  target="_blank"
                  rel="noopener noreferrer" className="aab"
                  style={{ color: isMe ? "#fff" : "#0d6efd", textDecoration: "underline" }}
                >
                  {part}
                </a>
              );
            } else {
              return part;
            }
          });
        };

        return (
          <div
            key={idx}
            className={`d-flex mb-3 ${isMe ? "justify-content-end" : ""}`}
            style={{ position: "relative" }}
          >
            {!isMe && (
              <img
                src={`${imageUrl}assignee/${activeUser.profile_image}`}
                alt={activeUser.full_name}
                className="rounded-circle me-2"
                width="35"
                height="35"
              />
            )}
            <div
              className={`p-2 rounded ${
                isMe ? "bg-primary text-white" : `crdf2 ${darkMode ? "dark" : ""}`
              } ${isPinned ? "pinned-msg" : ""}`}
              style={{ maxWidth: "70%", position: "relative", wordBreak: "break-word" }}
            >
              {renderMessage(msg.message)}
              {/* Pin Icon */}
              <span
                style={{
                  position: "absolute",
                  top: 0,
                  right: "-15px",
                  cursor: "pointer",
                  fontSize: "16px",
                  color: isPinned ? "#FFD700" : "#aaa",
                }}
                onClick={() => togglePin(msg)}
                title={isPinned ? "Unpin message" : "Pin message"}
              >
                {isPinned ? <BsFillHeartFill /> : <BiHeart />}
              </span>
            </div>
          </div>
        );
      })}

      <div ref={scrollRef}></div>
    </>
  )}
</div>


              {/* Chat Footer */}
              <div className="chat-footer border-top d-flex align-items-center p-2 bg-white">
                <input
                  type="text"
                  className="form-control me-2"
                  placeholder={`Message ${activeUser.full_name}`}
                  value={newMsg}
                  onChange={(e) => setNewMsg(e.target.value)}
                  onKeyDown={(e) => e.key === "Enter" && handleSend()}
                  disabled={loadingMessages}
                />
                <Send
                  className="text-primary"
                  size={20}
                  onClick={handleSend}
                  style={{ cursor: "pointer" }}
                />
              </div>


            



            </>
          )}

          <div
            className={`close-calendar mainttl ${darkMode ? "dark" : ""} m-2`}
            onClick={() => setShowChat(false)}
          >
            Close Messenger
          </div>
        </div>
      )}
    </>
  );
}
